import { BarLoader } from 'react-spinners';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues, getFormSyncErrors, getFormSubmitErrors } from 'redux-form';
import { Form, Input, message, Upload, Modal, Tabs, Icon } from 'antd';
import React, { Component } from 'react';
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

import {
  fetchBlog,
  addBlog,
  updateBlog
} from '../../actions/Blog';
import StatusControl from '../../components/StatusControl';
import MeNavBar from '../../components/MeNavBar';

const FormItem = Form.Item;
const { TextArea } = Input;
const TabPane = Tabs.TabPane;

class BlogCreate extends Component {

  constructor(props) {
    super(props)

    const { match, fetchBlog, blogs } = props;
    const { blogId } = match.params;

    let editorState = null;
    if (blogId) {
      const currentBlog = blogs[blogId];

      editorState = processInitialBlog(currentBlog);

      if (currentBlog) {
        // already have this blog in memory
        // editorState = processInitialBlog(currentBlog);
      } else {
        // fetch missing blog
        fetchBlog(blogId, (updatedBlog) => {
          // async
          const updatedEditorState = processInitialBlog(updatedBlog);
          this.setState({ editorState: updatedEditorState });
        });
      }
    } else {
      editorState = processInitialBlog();
    }

    this.state = {
      fileList: [],
      previewVisible: false,
      status: 0,
      editorState: editorState,
      activeTabKey: 'zh'
    }
  }

  componentDidMount() {
    const { match: { params }, blogs, fetchBlog } = this.props;
    const { blogId } = params;
    const blog = blogs[blogId];

    if (blogId || (blogId && !blog)) {
      fetchBlog(blogId);
    }
  }

  submitForm(values) {

    const { status, editorState: { en, th, zh }, fileList } = this.state;

    // content
    let contents = {};
    if (en) {
      contents.en = JSON.stringify(convertToRaw(en.getCurrentContent()));
    }
    if (th) {
      contents.th = JSON.stringify(convertToRaw(th.getCurrentContent()));
    }
    if (zh) {
      contents.zh = JSON.stringify(convertToRaw(zh.getCurrentContent()));
    }


    const updatedValues = {
      ...values,
      status: status,
      content: contents
    };

    // status
    // console.log(updatedValues);

    const { match: { params }, history } = this.props;
    const { blogId } = params;
    const imageFile = fileList.length > 0 ? fileList[0].originalFile : null;

    if (blogId) {
      // update

      this.props.updateBlog({ blog: updatedValues, coverImage: imageFile, id: blogId }, (error) => {
        if (error) {
          message.error('Error saving blog!');
        } else {
          message.success('Blog has been updated!');
          history.push('/blogs');
        }
      });
    } else {
      // create
      this.props.addBlog({ blog: updatedValues, coverImage: imageFile }, (error) => {
        if (error) {
          message.error('Error saving blog!');
        } else {
          message.success('Blog has been created!');
          history.push('/blogs');
        }
      });
    }


  }

  onTabChange(key) {
    this.setState({ activeTabKey: key });
  }

  onCoverModalClose() {
    this.setState({ previewVisible: false });
  }

  handlePreview(file) {
    this.setState({ previewVisible: true });
  }

  handleCoverChange({ fileList }) {

    console.log(fileList);

    this.setState({ fileList: fileList });
  }

  handleCoverDelete(file) {

    console.log(file);
  }

  customRequest(event) {

    const file = event.file;
    const reader = new FileReader();
    reader.onloadend = ((fr, ev) => {

      const originalFile = this.state.fileList[0];
      this.setState({
        fileList: [
          { ...file, url: reader.result, originalFile: originalFile }
        ]
      });
    });

    reader.readAsDataURL(file);
  }

  onStatusChange(status) {
    this.setState({ status: status });
  }

  onEditorStateChange(editorState, lang) {

    let updateState = { ...this.state.editorState };
    updateState[lang] = editorState;

    this.setState({ editorState: updateState });
  }

  renderField(field) {
    const { meta: { touched, error }, input } = field;
    const className = `form-group input-txt`;
    const validationStatus = `${touched ? (error ? 'error' : 'success') : ''}`;
    const help = `${touched && error ? error : ''}`;

    return (
      <FormItem
        label={field.label}
        colon
        // className={className}
        validateStatus={validationStatus}
        help={help}
        hasFeedback={field.required}
        required={field.required}
      >
        <Input
          {...input}
          className="form-control"
          placeholder={field.placeholder}
          size="large"
          type="text"
          addonBefore={field.addonBefore}
        />
      </FormItem>
    );
  }

  renderTextAreaField(field) {
    const { meta: { touched, error }, input } = field;
    const className = `form-group txt-area`;
    const validationStatus = `${touched ? (error ? 'error' : 'success') : ''}`;
    const help = `${touched && error ? error : ''}`;

    return (
      <FormItem
        label={field.label}
        colon
        // className={className}
        required={field.required}
        validateStatus={validationStatus}
        help={help}
      >
        <TextArea
          {...input}
          className="form-control"
          placeholder={field.placeholder}
          autosize={{ minRows: 5, maxRows: 20 }}
        />
      </FormItem>
    );
  }

  renderCoverImageView(cover) {
    const { previewVisible, fileList } = this.state;

    const uploadButton = (
      <div className="form-group add-more-btn button-upload">
        <img src="/resources/img/ic-add.png" alt="" />
        <label>Upload Image</label>
      </div>
    );

    let file = null;
    let src = cover;
    if (fileList.length > 0) {
      file = fileList[0];
      if (file.url) {
        src = file.url;
      }
    }

    return (
      <div className="news-icon" style={{ paddingLeft: 26, paddingRight: 26 }}>
        <Upload
          name="cover"
          listType="picture-card"
          className="product-image-uploader"
          // action="//jsonplaceholder.typicode.com/posts/"
          onChange={this.handleCoverChange.bind(this)}
          onPreview={this.handlePreview.bind(this)}
          fileList={fileList}
          onRemove={this.handleCoverDelete.bind(this)}
          accept="image/*"
          customRequest={this.customRequest.bind(this)}
        >
          {file ? null : uploadButton}
        </Upload>
        <Modal
          visible={previewVisible}
          footer={null}
          closable={false}
          onCancel={this.onCoverModalClose.bind(this)}
          width={800}
        >
          <img src={src ? src : ''} alt="" style={{ width: '100%' }} />
        </Modal>
      </div>
    );
  }

  renderEditor(editorState, { lang, title }) {
    return (
      <div>
        {/* <div className="form-group txt-area">
                    <label htmlFor="content-en">{`${title}:`}</label>
                </div> */}
        <Editor
          // initialEditorState={editorState[lang]}
          editorState={editorState[lang]}
          toolbarClassName="rdw-storybook-toolbar"
          // wrapperClassName="form-group txt-area"
          editorClassName="form-control"
          onEditorStateChange={(editorState) => this.onEditorStateChange(editorState, lang)}
          toolbar={{
            options: ['inline', 'blockType', 'list', 'textAlign', 'link', 'embedded', 'image', 'history'],
            inline: {
              inDropdown: false,
              options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace']
            },
            image: { uploadCallback: uploadImageCallBack, alt: { present: false, mandatory: false } },
          }}
        />
      </div>
    );
  }

  render() {
    const { location, handleSubmit, match: { params, path }, isBlogLoading, blogs, fields, fieldErrors } = this.props;
    const { editorState, activeTabKey } = this.state;
    const { blogId } = params;
    let isCreate = false;

    const blog = blogs[blogId];

    switch (path) {
      case '/blogs/:blogId':
        // edit
        break;
      case '/blogs/new':
        isCreate = true;
        break;
      default:
        break;
    }

    if ((!isCreate && !blogId) || (blogId && !blog)) {
      // not loaded
      return (
        <div className="container-fluid">
          <MeNavBar
            to={'/blogs'}
            title={`${isCreate ? 'New' : 'Edit'} - Blog`}
            hideButton
          />
          <div style={{ zIndex: 10, marginTop: 80 }}>
            <BarLoader loading={true} color={'#455963'} width={window.innerWidth} height={2} />
          </div>
        </div>
      );
    }

    // console.log(fields);

    return (
      <div className="detail-content-highlight">
        <form onSubmit={handleSubmit(this.submitForm.bind(this))}>
          <div className="container-fluid">
            <MeNavBar
              to={'/blogs'}
              title={`${isCreate ? 'New' : 'Edit'} - Blog`}
              buttonTitle={isCreate ? 'Add Blog' : 'Save'}
            />
            <div style={{ zIndex: 10, marginTop: 80 }}>
              <BarLoader loading={isBlogLoading} color={'#455963'} width={window.innerWidth} height={2} />
            </div>
            <div className="form-body">
              <div className="form-content">
                <div className="title">
                  <h5>Title</h5>
                  <div className="form-group txt-area">
                    <Tabs activeKey={activeTabKey} onChange={this.onTabChange.bind(this)} animated={false} >
                      <TabPane
                        tab="Chinese"
                        key="zh"
                      >
                        <Field
                          name="title_zh"
                          label="Blog Title"
                          placeholder="Blog Title (Chinese)"
                          component={this.renderField}
                          required
                        />
                      </TabPane>
                      <TabPane tab="English" key="en">
                        <Field
                          name="title_en"
                          label="Blog Title"
                          placeholder="Blog Title (English)"
                          component={this.renderField}
                          required
                        />
                      </TabPane>
                      <TabPane tab="Thai" key="th">
                        <Field
                          name="title_th"
                          label="Blog Title"
                          placeholder="Blog Title (Thai)"
                          component={this.renderField}
                        />
                      </TabPane>
                    </Tabs>
                  </div>
                </div>
                <div className="divider" />

                <div className="title">
                  <h5>Short Description</h5>
                  <div className="form-group txt-area">
                    <Tabs activeKey={activeTabKey} onChange={this.onTabChange.bind(this)} animated={false} >
                      <TabPane tab="Chinese" key="zh">
                        <Field
                          label="Short Description"
                          name="description_zh"
                          placeholder="Short Description (Chinese)"
                          component={this.renderTextAreaField}
                          required
                        />
                      </TabPane>
                      <TabPane tab="English" key="en">
                        <Field
                          label="Short Description"
                          name="description_en"
                          placeholder="Short Description (English)"
                          component={this.renderTextAreaField}
                        />
                      </TabPane>
                      <TabPane tab="Thai" key="th">
                        <Field
                          label="Short Description"
                          name="description_th"
                          placeholder="Short Description (Thai)"
                          component={this.renderTextAreaField}
                        />
                      </TabPane>
                    </Tabs>
                  </div>
                </div>
                <div className="divider" />

                <div className="cover-content">
                  <h5>{'Cover'}</h5>
                  {this.renderCoverImageView()}
                </div>
                <div className="divider" />

                <div className="cover-content">
                  <h5>Content</h5>
                  <div className="form-group txt-area">
                    <Tabs activeKey={activeTabKey} onChange={this.onTabChange.bind(this)} animated={false} >
                      <TabPane tab="Chinese" key="zh">
                        {this.renderEditor(editorState, { lang: 'zh', title: 'Content (Chinese)' })}
                      </TabPane>
                      <TabPane tab="English" key="en">
                        {this.renderEditor(editorState, { lang: 'en', title: 'Content (English)' })}
                      </TabPane>
                      <TabPane tab="Thai" key="th">
                        {this.renderEditor(editorState, { lang: 'th', title: 'Content (Thai)' })}
                      </TabPane>
                    </Tabs>
                  </div>


                </div>
                <div className="divider" />

                <StatusControl
                  selectedStatus={this.state.status}
                  options={[
                    {
                      title: 'Publish',
                      desc: 'Display this blog on website'
                    },
                    {
                      title: 'Unpublish',
                      desc: 'Hide this blog from website'
                    }
                  ]}
                  onChange={this.onStatusChange.bind(this)}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

function uploadImageCallBack(file) {

  // TODO: upload image files

}

function processInitialBlog(blog) {

  let editorStateEn = null;
  if (blog && blog.content && blog.content.en) {
    const contentStateEn = convertFromRaw(JSON.parse(blog.content.en));
    editorStateEn = EditorState.createWithContent(contentStateEn);
  } else {
    editorStateEn = EditorState.createEmpty();
  }

  let editorStateTh = null;
  if (blog && blog.content && blog.content.th) {
    const contentStateTh = convertFromRaw(JSON.parse(blog.content.th));
    editorStateTh = EditorState.createWithContent(contentStateTh);
  } else {
    editorStateTh = EditorState.createEmpty();
  }

  let editorStateZh = null;
  if (blog && blog.content && blog.content.zh) {
    const contentStateZh = convertFromRaw(JSON.parse(blog.content.zh));
    editorStateZh = EditorState.createWithContent(contentStateZh);
  } else {
    editorStateZh = EditorState.createEmpty();
  }

  const editorState = {
    en: editorStateEn,
    th: editorStateTh,
    zh: editorStateZh
  };

  return editorState;
}

function tab(title, error) {

  console.log(error);

  if (error) {
    return (
      <span style={{ color: '#f5222d' }}>
        {title}< Icon type="warning" style={{ color: '#f5222d' }} />
      </span >
    );
  }

  return (title);
}

function validate(values) {
  const errors = {};

  if (!values.title_en) {
    errors.title_en = 'Blog title cannot be empty';
  }
  if (!values.title_th) {
    errors.title_th = 'Blog title cannot be empty';
  }
  if (!values.title_zh) {
    errors.title_zh = 'Blog title cannot be empty';
  }

  if (!values.description_en) {
    errors.description_en = 'Blog short description cannot be empty';
  }
  if (!values.description_th) {
    errors.description_th = 'Blog short description cannot be empty';
  }
  if (!values.description_zh) {
    errors.description_zh = 'Blog short description cannot be empty';
  }

  return errors;
}

function mapStateToProps(state, ownProps) {
  const { blogs, isBlogLoading, errorMessage } = state.blog;

  const { blogId } = ownProps.match.params;
  const blog = blogs[blogId];

  let defaultVal = {};
  if (blog) {
    defaultVal = {
      ...blog,
    }
  } else {
    defaultVal = {
    }
  }

  return {
    blogs,
    isBlogLoading,
    initialValues: defaultVal,
    fields: getFormValues('BlogForm')(state),
    fieldErrors: getFormSyncErrors('BlogForm')(state)
  };
}

BlogCreate = reduxForm({
  validate,
  form: 'BlogForm',
  enableReinitialize: true
})(BlogCreate);

export default connect(mapStateToProps, {
  fetchBlog,
  addBlog,
  updateBlog
})(BlogCreate);



// WEBPACK FOOTER //
// ./src/views/blogs/Create.js